import { useEffect, useState } from 'react';
import { Divider } from '@barkibu/noma-commons';
import CostLine from '../../../../../domain/entities/CostLine';
import Invoice from '../../../../../domain/entities/Invoice';
import InvoiceHeader from '../invoice-header/InvoiceHeader';
import InvoiceCostLines from '../invoice-cost-lines/InvoiceCostLines';
import InvoiceTotals from '../invoice-totals/InvoiceTotals';
import './invoice-form.modules.scss';

export type InvoiceFormProps = {
    invoice: Invoice;
    readOnly: boolean;
    onUpdateClinic: (key: string, clinic: string) => void;
    onUpdateCostLines: (key: string, costLines: CostLine[]) => void;
    onUpdateDate: (key: string, date: Date) => void;
    onUpdateDiscount: (key: string, discount: number) => void;
    onUpdateNumber: (key: string, number: string) => void;
    onUpdateTaxIdNumber: (key: string, taxIdNumber: string) => void;
    onDeleteInvoice?: (invoiceKey: string) => void;
    claimRequestKey?: string;
    title?: string;
};

const InvoiceForm = ({
    invoice,
    readOnly,
    onUpdateClinic,
    onUpdateCostLines,
    onUpdateDate,
    onUpdateDiscount,
    onUpdateNumber,
    onUpdateTaxIdNumber,
    onDeleteInvoice,
    claimRequestKey,
    title,
}: InvoiceFormProps) => {
    const [clinicSelected, setClinicSelected] = useState(invoice.providerName);
    const [discountSelected, setDiscountSelected] = useState(invoice.discountInCents);

    useEffect(() => {
        setClinicSelected(invoice.providerName);
        setDiscountSelected(invoice.discountInCents);
    }, [invoice]);
    const handleClinicChange = (clinic: string) => {
        setClinicSelected(clinic);
    };
    const handleClinicTouched = () => {
        if (clinicSelected != null) {
            onUpdateClinic(invoice.key!, clinicSelected);
        }
    };
    const handleDiscountChange = (discountInCents: number) => {
        setDiscountSelected(discountInCents);
    };
    const handleDiscountTouched = () => {
        if (discountSelected != null) {
            onUpdateDiscount(invoice.key!, discountSelected);
        }
    };
    const handleUpdateCostLine = (costLines: CostLine[]) => {
        onUpdateCostLines(invoice.key!, costLines);
    };

    return (
        <div className="invoice-form">
            <InvoiceHeader
                readOnly={readOnly}
                invoice={invoice}
                title={title}
                onUpdateDate={onUpdateDate}
                onUpdateNumber={onUpdateNumber}
                onUpdateTaxIdNumber={onUpdateTaxIdNumber}
                claimRequestKey={claimRequestKey}
                onDeleteInvoice={onDeleteInvoice != null && !readOnly ? () => onDeleteInvoice(invoice.key!) : undefined}
            />
            <Divider />
            <InvoiceCostLines
                costLinesDefault={invoice.costLines}
                currency={invoice.currency}
                readOnly={readOnly}
                onUpdateCostLines={handleUpdateCostLine}
            />
            <Divider />
            <InvoiceTotals
                readOnly={readOnly}
                costLines={invoice.costLines}
                currency={invoice.currency}
                clinic={clinicSelected ?? ''}
                discount={discountSelected ?? 0}
                handleClinicChange={handleClinicChange}
                handleClinicTouched={handleClinicTouched}
                handleDiscountChange={handleDiscountChange}
                handleDiscountTouched={handleDiscountTouched}
            />
        </div>
    );
};

export default InvoiceForm;
